import { render, staticRenderFns } from "./inspectplanandproject.vue?vue&type=template&id=fa683c18&"
import script from "./inspectplanandproject.vue?vue&type=script&lang=js&"
export * from "./inspectplanandproject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports